import React from 'react';
import { useSelector } from 'react-redux';

import { Page } from 'ui/components';
import {
  SkeletonTable,
  SkeletonPageFooter,
} from 'ui/components/skeleton';

import useTable from 'ui/components/table';

import tableConfig from './component/table.config';

const TransactionScreen = () => {
  const TransactionTable = useTable('transaction_journal', tableConfig);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Table.Request']
  );

  return (
    <Page className="fixed ">
      <Page.Header
        pretitle="Daftar"
        title={'Transaksi Journal'}
        isLoading={StateLoading}
        action={{ url: '/accounting/transaction/create', text: 'Buat Transaksi Journal' }}
      />

      <Page.Navigation toolbar>
        <TransactionTable.Tools isLoading={StateLoading} />
      </Page.Navigation>

      <Page.Body className="row m-0 p-0">
        <div className='col-md-12 m-0 p-0'>
          {StateLoading ? (
            <SkeletonTable headerCount={9} bodyCount={9} />
          ) : (
            <TransactionTable.Render />
          )}
        </div>
      </Page.Body>
      <Page.Footer>
        {StateLoading ? <SkeletonPageFooter /> : <TransactionTable.Pagination />}
      </Page.Footer>
    </Page>
  );
};

export default TransactionScreen;
